module.exports = __webpack_public_path__ + "img/file-excel.abacae34.svg";